import React, { useEffect } from 'react'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import { mapDispatchToProps } from '../../../helpers/redux.helper'
import { getLanguagesFromVoices } from '../../../helpers/voice.helper'
import './index.sass'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import Breadcrumbs from '../../Breadcrumbs'
import ScrollUpButton from '../../ScrollUpButton'

const AllLanguages = (props) => {
    const {t, lng, voices, actions: { getVoicesList }} = props
    const path = lng === 'en' ? '' : `/${lng}`
    useEffect(()=>{
        getVoicesList()
    },[])
    return (
      <>
      <Helmet>
          <html lang={lng} />
          <title>{t('home.foreigns.allLanguages.title')}</title>
          <link rel="alternate" hrefLang="en"
              href="https://unimedia.io/all-languages" />
          <link rel="alternate" hrefLang="de"
              href="https://unimedia.io/de/all-languages" />
          <link rel="alternate" hrefLang="ru"
              href="https://unimedia.io/ru/all-languages" />
          <link rel="alternate" hrefLang="x-default"
              href="https://unimedia.io/all-languages" />
          <meta name="description" content={t('home.foreigns.allLanguages.description')} />
          {lng === 'en' && <meta name="keywords" content={t('meta.home.keywords')} />}
          {lng === 'en' ? <link rel="canonical" href={'https://unimedia.io/all-languages'} /> : <link rel="canonical" href={`https://unimedia.io/${lng}/all-languages`} />}
          <meta property="og:title" content={t('home.foreigns.allLanguages.title')} />
          <meta property="og:description" content={t('home.foreigns.allLanguages.description')} />
          <meta property="og:image" content="https://unimedia.io/assets/logo.svg" />
          <meta property="og:url" content={lng === 'en' ? 'https://unimedia.io/all-languages': `https://unimedia.io/${lng}.all-languages`} />
          <script type="application/ld+json">
          {`[{
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [{
                "@type": "ListItem",
                "position": 1,
                "name": "${t('navigations.home')}",
                "item": "https://unimedia.io"
              },{
                "@type": "ListItem",
                "position": 2,
                "name": "${t('home.foreigns.allLanguages.subtitle')}"
              }]
            }]`}
          </script>
        </Helmet>
        <ScrollUpButton id={'all-languages'} />
        <div className='main-container' id={'all-languages'}>
        <Breadcrumbs pathname={window.location.pathname} color='white'/>
            <h1 style={{color: 'white', textTransform: 'uppercase'}}>
                {t(`home.foreigns.allLanguages.subtitle`)}
            </h1>
            <div className='allLanguages-voicesWrapper'>
              {getLanguagesFromVoices(voices).map(voice=> {
                // if (lng ==='ru' && EXCLUDED_DE_VOICES.includes(voice)) {
                //   return (
                //     <div className='allLanguages-voiceItem-inactive'>{t(`Language.${voice}`)}</div>
                //   )
                // } else {
                  return (
                    <Link
                    key={voice}
                    className={'allLanguages-voiceItem'}
                    to={`${path}/voices/${voice.toLowerCase().split(' ').join('-')}`}
                    >
                      {t(`Language.${voice}`)}
                    </Link>
                  )
                  // }
              })}
            </div>
        </div>
        </>
    )
}

const mapStateToProps = state => ({
    voices: state.voices,
  })

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(AllLanguages))